<template>
  <a-form layout="vertical" :model="filters">
    <a-form-item label="Название">
      <a-input v-model:value="filters.name" />
    </a-form-item>

    <a-row :gutter="10">
      <a-col>
        <a-form-item label="Активность">
          <a-input v-model:value="filters.job_title" placeholder="Название должности" />
        </a-form-item>
      </a-col>

      <a-col>
        <a-form-item label="Отдел">
          <a-input v-model:value="filters.department" placeholder="Название отдела" />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="10">
      <a-col :span="12">
        <a-form-item label="Дата добавления" name="created_at">
          <a-date-picker
              v-model:value="filters.created_at"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </a-form-item>
      </a-col>

      <a-col :span="12">
        <a-form-item label="Последнее изменение" name="updated_at">
          <a-date-picker
              v-model:value="filters.updated_at"
              type="date"
              placeholder="Выберите дату"
              style="width: 100%"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row justify="end" :gutter="8">
      <a-col>
        <a-button :class="'secondary-button'" @click="closeForm">Отменить</a-button>
      </a-col>
      <a-col>
        <a-button :class="'primary-button'" @click="updateFilters">Применить</a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import {reactive, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";

  export default {
    emits: ['close'],
    setup(props, context) {
      const currentFiltersLine = ref('');
      const store = useStore();

      const storedFilters = computed(() => store.state.group.filters);

      const filters = reactive({
        name: storedFilters.value.name ?? '',
        job_title: storedFilters.value.job_title ?? '',
        department: storedFilters.value.department ?? '',
        updated_at: storedFilters.value.updated_at ?? '',
        created_at: storedFilters.value.created_at ?? '',
      });

      const filterStringLabels = {
        name: 'Название',
        job_title: 'Должность',
        department: 'Отдел',
        updated_at: 'Дата создания',
        created_at: 'Последнее изменение',
      }

      const buildInputLineString = () => {
        currentFiltersLine.value = '';
        Object.entries(filterStringLabels).map(
            ([key, value]) => {
              if (filters[key]) {
                let newString;

                if (key === 'created_at' || key === 'updated_at') {
                  newString = `${value}: ${filters[key].format('DD.MM.YYYY')}`;
                } else {
                  newString = `${value}: ${filters[key]}`;
                }

                if (newString) {
                  currentFiltersLine.value = (currentFiltersLine.value ? currentFiltersLine.value + ', ' : '') + `${newString}`
                }
              }
            }
        );
      }

      const updateFilters = () => {
        buildInputLineString();
        store.dispatch('group/setGroupFilters', {
          filters: filters,
          filterString: currentFiltersLine,
        });

        closeForm();
      }

      const closeForm = () => {
        context.emit('close');
      }

      watch(() => storedFilters, () => {
        filters.name = storedFilters.value.name ?? '';
        filters.job_title = storedFilters.value.job_title ?? '';
        filters.department = storedFilters.value.department ?? '';
        filters.updated_at = storedFilters.value.updated_at ?? '';
        filters.created_at = storedFilters.value.created_at ?? '';
      });

      return {
        filters,
        updateFilters,
        closeForm,
      }
    }
  }
</script>

<style scoped lang="scss">
  :deep(.ant-form-item-label) {
    padding-bottom: 4px !important;
  }

  :deep(.ant-form-item) {
    margin-bottom: 12px;
  }
</style>